<template>
    <modal @modal-close="$emit('close')">

        <div class="modal-wrapper">

            <CloseButton @click="$emit('close')" />

            <div class="modal-content">
                <div class="item" v-if="notification.subject">
                    <h4>{{ $t("Title") }}</h4>
                    <p>{{ notification.subject }}</p>
                </div>

                <div class="item" v-if="notification.message">
                    <h4>{{ $t("Description") }}</h4>
                    <div v-html="notification.message"></div>
                </div>

                <div class="item" v-if="notification.created_at">
                    <h4>{{ $t("Date") }}</h4>
                    <p>{{ $du(notification.created_at, 'shortDateTime') }}</p>
                </div>

            </div>

        </div>

    </modal>
</template>

<script>
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {
    components: { CloseButton },

    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
};
</script>
